import React, { useEffect, useState } from "react";
import {
    generategroupid,
    settingcreate,
    settinglist,
} from "../../services/setting";
import { toast } from "react-toastify";
import { BackupManagement } from "./setting/backupmanagement";

export const Settings = () => {
    const [activeTab, setActiveTab] = useState("general");
    const [group, setGroup] = useState("Automatic");
    const [groupId, setGroupId] = useState("");
    const [grpprf, setGrpPrf] = useState("");
    const [grpsuf, setGrpSuf] = useState("");
    const [cutoff, setCutoff] = useState("10:00");
    const [compName, setCompName] = useState("");
    const [compAddr, setCompAddr] = useState("");

    useEffect(() => {
        settinglist().then((res) => {
            if (res.status === true) {
                if (res.data !== null) {
                    setGroup(res.data.group);
                    setGrpPrf(res.data.group_prefix);
                    setGroupId(res.data.group_number);
                    setGrpSuf(res.data.group_suffix);
                    if (res.data.clock_in_cutoff) {
                        // Stored as HH:MM:SS, the time input wants HH:MM.
                        setCutoff(res.data.clock_in_cutoff.substring(0, 5));
                    }
                    setCompName(res.data.company_name ?? "");
                    setCompAddr(res.data.company_address ?? "");

                } else {
                    handlegroup({ target: { value: "Automatic" } });
                }
            } else {
                handlegroup({ target: { value: "Automatic" } });
            }
        });
    }, []);

    function handlegroup(e) {
        setGroup(e.target.value);
        setGroupId("");
        setGrpPrf("");
        setGrpSuf("");
        if (e.target.value === "Automatic") {
            generategroupid().then((res) => {
                if (res.status === true) {
                    if (res.data !== null) {
                        setGrpPrf(res.data.group_prefix);
                        setGroupId(res.data.group_number);
                        setGrpSuf(res.data.group_suffix);
                    }
                }
            });
        } else {
            setGroupId("");
            setGrpPrf("");
            setGrpSuf("");
        }
    }

    function handlesubmit(e) {
        e.preventDefault();
        const temp = new FormData();
        temp.append("group_prefix", grpprf);
        temp.append("group_number", groupId);
        temp.append("group_suffix", grpsuf ? grpsuf : "");
        temp.append("group", group);
        temp.append("clock_in_cutoff", cutoff ? cutoff + ":00" : "");
        temp.append("company_name", compName);
        temp.append("company_address", compAddr);
        settingcreate(temp).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
            }
        });
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Settings</h2>
                {/* <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Settings</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Settings
          </li>
        </ol> */}
            </div>
            <div className="tabs-container mb-3">
                <div className="tabs-menu">
                    <button
                        className={`tab-button ${activeTab === "general" ? "active" : ""}`}
                        onClick={() => setActiveTab("general")}
                    >
                        <i className="fa fa-cog"></i> General
                    </button>
                    <button
                        className={`tab-button ${activeTab === "backup" ? "active" : ""}`}
                        onClick={() => setActiveTab("backup")}
                    >
                        <i className="fa fa-database"></i> Data Backup
                    </button>
                </div>
            </div>
            {activeTab === "backup" && <BackupManagement embedded={true} />}
            <div
                className="content-body"
                style={{ display: activeTab === "general" ? "block" : "none" }}
            >
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">Settings</h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Group<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                aria-label="Default select example"
                                                value={group}
                                                onChange={(e) => handlegroup(e)}
                                            >
                                                <option value="" selected disabled>
                                                    Select Group
                                                </option>
                                                <option value="Manual">Manual</option>
                                                <option value="Automatic">Automatic</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            {/* <label className="form-label">Group ID <span className="text-danger"> *</span></label> */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Prefix <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Prefix"
                                                            value={grpprf}
                                                            onChange={(e) => setGrpPrf(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Number <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Number"
                                                            value={groupId}
                                                            onChange={(e) => setGroupId(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Suffix 
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Suffix"
                                                            value={grpsuf}
                                                            onChange={(e) => setGrpSuf(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <input type="text" className="form-control" placeholder="Group ID" value={groupId} onChange={(e) => setGroupId(e.target.value)} /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Clock In Cutoff Time
                                            </label>
                                            <input
                                                type="time"
                                                className="form-control"
                                                value={cutoff}
                                                onChange={(e) => setCutoff(e.target.value)}
                                            />
                                            <small className="text-muted">
                                                Staff clocking in after this time need admin approval.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <h4 className="mt-2 mb-3">Company (Payslip Header)</h4>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Company Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Company Name"
                                                value={compName}
                                                onChange={(e) => setCompName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Company Address</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Company Address"
                                                value={compAddr}
                                                onChange={(e) => setCompAddr(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <a
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={handlesubmit}
                                        >
                                            Submit
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
